export default "__VITE_ASSET__53525661__"